import type { Level, LevelRecord, Phase } from "./types";
import { euclideanMatrix } from "@jpjj/solver-core/routing";
import { LEVELS } from "./levels";

/** Distance matrices are fixed per level — compute once. */
const MATRICES = LEVELS.map((L) => euclideanMatrix(L.points));

/** Mutable, session-global game state, kept in one object so feature modules
 *  can share it without a tangle of cross-module setters. */
export const state = {
  /** The current level definition. */
  level(): Level { return LEVELS[this.idx]; },
  /** Distance matrix of the current level (map units). */
  dist(): number[][] { return MATRICES[this.idx]; },
  /** Number of ports to visit on the current level (harbor excluded). */
  portCount(): number { return LEVELS[this.idx].points.length - 1; },
  phase: "intro" as Phase,
  /** Current level index. */
  idx: 0,
  /**
   * The route being charted: port indices in visiting order (1-based node
   * indices into level.points; the leading harbor 0 is implicit). The closing
   * leg back home is implicit once every port appears.
   */
  route: [] as number[],
  /** Whether each voyage has been sailed at the proven shortest length. */
  completed: LEVELS.map(() => false),
  /** Persisted working route per level, so navigating back restores work. */
  saved: LEVELS.map(() => [] as number[]),
  /** Best completed round per level (lowest length), fed to the reveal. */
  records: LEVELS.map((): LevelRecord => ({ order: [], length: 0 })),
};

/** Distance matrix for an arbitrary level (used by the reveal's mini charts). */
export function matrixFor(levelIdx: number): number[][] {
  return MATRICES[levelIdx];
}
